"use client";

import React, { useContext, useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Dropdown from "../../../sharedComponent/DropDown/DropDown";
import {
  deleteWithAuthCall,
  patchMultipartWithAuthCall,
  putMultipartWithAuthCall,
  putWithAuthCall,
  simpleGetCall,
  simplePatchCall,
} from "../../../api/ApiServices";
// import ApiConfig from "../../../api/ApiConfig";
import { AppContext } from "../../../context/AppContext";
import Loader from "../../Loader";
import NoData from "../../../sharedComponent/NoData";
import Form from "react-bootstrap/Form";
import { ToastMsg } from "../../TostMsg";
import Select from "react-select";
import PriceUpdateModal from "../BaseMenu/PriceUpdateModal";
import ItemVariationModal from "./ItemVariationModal";

const initialTabs = [
  {
    id: "fruits-vegetables",
    name: "Fruits and Vegetables",
    items: [
      {
        id: "1",
        name: "Watermelon",
        category: "Fruits",
        code: "100",
        price: "100",
        description: "A refreshing summer fruit",
        availability: true,
      },
      {
        id: "2",
        name: "Mango",
        category: "Fruits",
        code: "101",
        price: "120",
        description: "Sweet tropical fruit",
        availability: false,
      },
    ],
  },
  {
    id: "desserts",
    name: "Desserts",
    items: [
      {
        id: "3",
        name: "Chocolate Cake",
        category: "Bakery",
        code: "102",
        price: "200",
        description: "Rich and moist chocolate cake",
        availability: true,
      },
      {
        id: "4",
        name: "Ice Cream",
        category: "Frozen",
        code: "103",
        price: "80",
        description: "Vanilla ice cream",
        availability: true,
      },
    ],
  },
  {
    id: "dairy-eggs",
    name: "Dairy and Eggs",
    items: [
      {
        id: "5",
        name: "Milk",
        category: "Dairy",
        code: "200",
        price: "50",
        description: "Fresh milk",
        availability: true,
      },
      {
        id: "6",
        name: "Eggs",
        category: "Eggs",
        code: "201",
        price: "60",
        description: "Farm fresh eggs",
        availability: true,
      },
    ],
  },
  {
    id: "chicken-meal",
    name: "Chicken Meal",
    items: [
      {
        id: "7",
        name: "Grilled Chicken",
        category: "Poultry",
        code: "202",
        price: "300",
        description: "Delicious grilled chicken",
        availability: true,
      },
      {
        id: "8",
        name: "Chicken Curry",
        category: "Cuisine",
        code: "203",
        price: "250",
        description: "Spicy chicken curry",
        availability: false,
      },
    ],
  },
  {
    id: "herbs-greens",
    name: "Herbs and Greens",
    items: [
      {
        id: "9",
        name: "Spinach",
        category: "Leafy Greens",
        code: "204",
        price: "40",
        description: "Fresh green spinach",
        availability: true,
      },
      {
        id: "10",
        name: "Coriander",
        category: "Herbs",
        code: "205",
        price: "20",
        description: "Aromatic coriander leaves",
        availability: true,
      },
    ],
  },
  {
    id: "hot-coffees",
    name: "Hot Coffees",
    items: [
      {
        id: "11",
        name: "Espresso",
        category: "Beverage",
        code: "300",
        price: "150",
        description: "Rich and bold coffee",
        availability: true,
      },
      {
        id: "12",
        name: "Latte",
        category: "Beverage",
        code: "301",
        price: "180",
        description: "Smooth and creamy coffee",
        availability: true,
      },
    ],
  },
  {
    id: "side-orders",
    name: "Side Orders",
    items: [
      {
        id: "13",
        name: "Garlic Bread",
        category: "Appetizers",
        code: "302",
        price: "70",
        description: "Crispy garlic bread",
        availability: false,
      },
      {
        id: "14",
        name: "French Fries",
        category: "Snacks",
        code: "303",
        price: "90",
        description: "Crispy golden fries",
        availability: true,
      },
    ],
  },
  {
    id: "seafood-meal",
    name: "Seafood Meal",
    items: [
      {
        id: "15",
        name: "Grilled Salmon",
        category: "Seafood",
        code: "304",
        price: "400",
        description: "Freshly grilled salmon",
        availability: true,
      },
      {
        id: "16",
        name: "Shrimp Curry",
        category: "Cuisine",
        code: "305",
        price: "350",
        description: "Spicy shrimp curry",
        availability: false,
      },
    ],
  },
];

const actions = [
  { value: "update_price", label: "Increase/Reduce Price" },
  { value: "available", label: "Available" },
  { value: "unavailable", label: "Unavailable" },
  { value: "ignore_tax", label: "Ignore Tax" },
  { value: "ignore_discount", label: "Ignore Discount" },
  { value: "mark_favourite", label: "Mark as Favourite" },
  { value: "unmark_favourite", label: "Unmark as Favourite" },
  { value: "mark_veg", label: "Mark as Vegetarian" },
  { value: "mark_non_veg", label: "Mark as Non-Vegetarian" },
];

console.log(actions);

const Items = ({menuId}) => {
  const { selectedStoreID,selectedRestID,activeTabId, ApiConfig,setActiveTabId } = useContext(AppContext);

  const navigate = useNavigate();
  const [tabs, setTabs] = useState(initialTabs);
  console.log("activeTabId==Item",activeTabId)
    const [showModal, setShowModal] = useState(false);
    const [categoriesData, setCategoriesData ] = useState([]); 
     const handleSave = (payload) => {
    console.log("SEND TO API:", payload);
    // API CALL HERE
  };
    // taleeb
  
  const [draggedTabId, setDraggedTabId] = useState(null);
  // const [switchStates, setSwitchStates] = useState(false);
  const [itemList, setItemList] = useState([0]);
  const [categoryList, SetCategoryList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(false);
  const [rank, setRank] = useState("");
  const [actionsValue, setActionValue] = useState([]);
  const [activeAction, setActiveAction] = useState("");

  const [switchStates, setSwitchStates] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [editingPriceId, setEditingPriceId] = useState(null);
  const [editingPriceValue, setEditingPriceValue] = useState("");
  const [showQuickEdit, setShowQuickEdit] = useState(false);
  const [variationModalItem, setVariationModalItem] = useState(null);
  const [quickEditData, setQuickEditData] = useState({
    id: null,
    item_name: "",
    item_price: "",
    item_description: "",
    item_allow_variation: 0,
  });

  console.log("actionsValue>>>>", actionsValue);

  const handleToggle = (itemId) => {
    setSwitchStates((prevStates) => {
      const updatedState = !prevStates[itemId]; // Toggle only the clicked item

      // Create the required body format
      const requestBody = {
        id: itemId,
        is_available: updatedState,
        menu_id : menuId
      };

      console.log("Sending API Request:", requestBody); // Log API body before sending

      // Call the API function to update backend
      onChangeToggle(requestBody);

      return {
        ...prevStates,
        [itemId]: updatedState, // Update only the clicked item
      };
    });
  };

  useEffect(() => {
    if (itemList?.length) {
      const initialStates = itemList.reduce((acc, item) => {
        acc[item.item_id] = item.is_available === true;
        return acc;
      }, {});
      setSwitchStates(initialStates);
    }
  }, [itemList]);
  const handleDragStart = (id) => {
    setDraggedTabId(id);
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Allow drop
  };

  const handleDrop = (targetId) => {
    if (!draggedTabId) return;

    const draggedIndex = tabs.findIndex((tab) => tab.id === draggedTabId);
    const targetIndex = tabs.findIndex((tab) => tab.id === targetId);

    if (draggedIndex === -1 || targetIndex === -1) return;

    const updatedTabs = [...tabs];
    const [draggedTab] = updatedTabs.splice(draggedIndex, 1);
    updatedTabs.splice(targetIndex, 0, draggedTab);

    setTabs(updatedTabs);
    setDraggedTabId(null);
  };

  const handleACtion = (select) => {
    console.log("select>>>>>", select);

    if (select.value === "update_price") {
      setShowModal(true)
      return;
    }
    setActiveAction(select.value);
    const data = actionsValue?.data?.map((id) => {
      return id;
    });
    const body = {
      action: select.value,
      ids: data,
    };
    putWithAuthCall(ApiConfig.UPDATE_ACTION, JSON.stringify(body))
      .then((res) => {
        if (res?.success === true) {
          ToastMsg("success", res?.message);
          getItemList();
          setActionValue([]);
        } else {
          ToastMsg("error", res?.message);
        }
        console.log(res);
      })
      .catch((err) => [console.log(err)]);
  };
  console.log("selectedStoreID>>>", selectedStoreID);
 













  const handleDelete = (select) => {
    console.log("select>>>>>", select);


    const body = {
      shop_id: selectedStoreID,
      ids: [select],
      menu_id : menuId
    };
    deleteWithAuthCall(ApiConfig.deleteproducts, JSON.stringify(body))
      .then((res) => {
        if (res?.success === true) {
          ToastMsg("success", res?.message);
          getItemList();
          setActionValue([]);
        } else {
          ToastMsg("error", res?.message);
        }
        console.log(res);
      })
      .catch((err) => [console.log(err)]);
  };



  const handleQuickEditOpen = (item) => {
    setQuickEditData({
      id: item.item_id,
      item_name: item.item_name || "",
      item_price: item.item_price || "",
      item_description: item.item_description || "",
      item_allow_variation: item.item_allow_variation || 0,
    });
    setShowQuickEdit(true);
  };

  const handleQuickEditSave = () => {
    const body = {
      id: quickEditData.id,
      item_name: quickEditData.item_name,
      item_price: quickEditData.item_price,
      item_description: quickEditData.item_description,
      item_allow_variation: quickEditData.item_allow_variation,
    }; 
    if(menuId){
      body.menu_id = menuId
    }
    simplePatchCall(ApiConfig.PARTAL_UPDATE, body)
      .then((res) => {
        if (res?.success === true) {
          ToastMsg("success", res?.message);
          getItemList();
          setShowQuickEdit(false);
        } else {
          ToastMsg("error", res?.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false);
      setActionValue([]);
    } else {
      setSelectAll(true);
      setActionValue({ data: itemList.map((item) => item.item_id) });
    }
  };

  const handlePriceEdit = (item) => {
    setEditingPriceId(item.item_id);
    setEditingPriceValue(item.item_price);
  };

  const handlePriceSave = (itemId) => {
    const body = {
      action: "update_price",
      ids: [itemId],
      price: editingPriceValue,
    };
    putWithAuthCall(ApiConfig.UPDATE_ACTION, JSON.stringify(body))
      .then((res) => {
        if (res?.success === true) {
          ToastMsg("success", res?.message);
          getItemList();
        } else {
          ToastMsg("error", res?.message);
        }
      })
      .catch((err) => console.log(err));
    setEditingPriceId(null);
  };

  const handleCheckboxChange = (id) => {
    setActionValue((prevState) => {
      const data = prevState.data || [];
      const exists = data.includes(id);
      const newData = exists ? data.filter((i) => i !== id) : [...data, id];
      const allSelected = itemList.length > 0 && newData.length === itemList.length;
      setSelectAll(allSelected);
      return { ...prevState, data: newData };
    });
  };
  useEffect(() => {
    const fetchAndSetInitialCategory = async () => {
      if (selectedStoreID) {
        // Ensure we have a store ID
        try {
          const response = await simpleGetCall(
            `${
              ApiConfig?.GET_CATEGORY_LIST_DATA
            }${selectedStoreID}&search=${""}`
          );

          if (response.success === true && response.data?.length > 0) {
            const categories = response.data;
            SetCategoryList(categories); // Set the full list of categories

            // *** THIS IS THE KEY CHANGE ***
            // Set the activeTab to the ID of the first category in the list.
            // setActiveTabId(categories[0].id);
          } else {
            SetCategoryList([]); // Handle case with no categories
            console.log("No categories found or API error.");
          }
        } catch (err) {
          console.error("Category fetching API Error:", err);
        }
      }
    };

    fetchAndSetInitialCategory();
  }, [selectedStoreID,selectedRestID]);

  const getItemList = (search = "") => {
    setLoading(true);
    simpleGetCall(
      ApiConfig?.GET_ITEM_LIST +
        `?category_id=${activeTabId}&shop_id=${selectedStoreID}${menuId ? `&menu_id=${menuId}` : ""}&product_name=${search}&sort=${
          rank ? rank : ""
        }`
    )
      .then((res) => {
        if (res.success === true) {
          setLoading(false);
          setItemList(res?.data);
        } else {
          setLoading(false);
        }
        console.log("Items ResPonse>>>>", res);
      })
      .catch((err) => {
        console.log("Items ResPonse Err>>>>", err);
      });
  };

  const fetchCategoryList = async () => {
    // setLoading(true)

    try {
      const response = await simpleGetCall(
        `${ApiConfig?.GET_CATEGORY_LIST_DATA}${selectedStoreID}&search=${""}`
      );
      if (response.success === true) {
        // setLoading(false)
        const category = response?.data;
        console.log("categoryList>>>>", category);
        SetCategoryList(category);
      } else {
        console.log("CateGory Error>>>>>");

        // setLoading(false)
      }
    } catch (err) {
      console.error("Dropdown API Error:", err);
    }
  };

  const onChangeToggle = (body) => {
    patchMultipartWithAuthCall(ApiConfig.TOGGLE_ON_OF, JSON.stringify(body))
      .then((response) => {
        console.log("API Response:", response);
        if (response.json.success === true) {
          ToastMsg("success", response?.json.message);
          getItemList();
        } else {
          ToastMsg("error", response?.json.message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  // const onUpdateRank = () => {
  //   setLoading(true)
  //   const body = {

  //   }
  //   console.log("body>>>", body)

  //   patchMultipartWithAuthCall(ApiConfig.UPDATE_VARIATION_RANK, JSON.stringify(body))
  //     .then((res) => {
  //       console.log("res>>>", res.json?.message)
  //       if (res.json?.success === true) {
  //         notifySuccess(res.json?.message)
  //         getVariantList()
  //         setRankData("")
  //         setLoading(false)
  //       } else {
  //         notifyError(res.json?.message)
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err>>>", err)
  //     })
  // }

  useEffect(() => {
    if(selectedStoreID){
    fetchCategoryList();
    categoryLookUpFunction();
    }
  }, [selectedStoreID]);

  useEffect(() => {
    if(activeTabId) {
    getItemList(searchName);
    }
  }, [searchName, activeTabId, selectedStoreID, rank, menuId]);




    const categoryLookUpFunction = async () => {
      setLoading(true);
      try {
        const response = await simpleGetCall(
         
          `${ApiConfig.GET_Catagrilist_Lookup}${selectedStoreID}`
        );
        setLoading(false);
  
        const apiCats = response.data || [];
        console.log('taleeb_apiCats--', apiCats)
        setCategoriesData(apiCats);
        // taleeb
  
     
      } catch (err) {
        setLoading(false);
        console.error("Category API Error:", err);
      }
    };

  return (
    <div className="flex h-screen mt-2 p-3">
      {/* Draggable Sidebar */}
      <ul
        style={{
          padding: 0,
          margin: 0,
        }}
      >
        {categoryList.map((tab) => (
          <li
            key={tab.id}
            onDragStart={() => handleDragStart(tab.id)}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop(tab.id)}
            onClick={() => setActiveTabId(tab.id)}
            className={`flex  py-2 ps-1 font-size-14 border-bottom ${
              activeTabId === tab.id ? "border-left" : "bg-white text-gray "
            }`}
          >
            {/* Tab Name */}
            <span
              className={`width165 ${activeTabId === tab.id ? "blue-text" : ""}`}
            >
              {tab.category_name}
            </span>
          </li>
        ))}
      </ul>

      {/* Main Content */}
      <div className="w-full bg-white  border ms-2 py-2">
        <div className="d-flex flex-wrap align-items-center p-2">
          {/* Fullscreen Icon */}

          {/* Input Box */}
          <div className="me-2 ">
            <input
              type="text"
              placeholder="Search.."
              className="dropdown-button flex items-center justify-between bg-white border border-gray-300  py-2 rounded shadow-md hover:bg-gray-100 focus:outline-none px-2"
              onChange={(e) => setSearchName(e.target.value)}
            />
          </div>

          {/* Dropdowns */}
          <div className="d-flex flex-wrap">
            {/* First Dropdown */}
            <Select
              options={actions}
              onChange={handleACtion}
              placeholder="Select Action"
            />

            {/* taleeb */}
 {/* <button onClick={() => setShowModal(true)}>
        Update Item Prices
      </button> */}
            <div className="me-2" />

            {/* Second Dropdown */}
            {/* <Dropdown
              data={["Option 1", "Option 2"]}
              placeholder="Quick Actions"
              className="me-2"
              isOpen={openDropdown === "dropdown2"}
              setOpenDropdown={() =>
                setOpenDropdown(
                  openDropdown === "dropdown2" ? null : "dropdown2"
                )
              }
            /> */}

            <div className="me-2" />
            <div className="w-20 w-sm-auto text-center">
              {/* <button

                className="btn ms-4 d-flex align-items-center" style={{backgroundColor:"#53B7E8", color:"#fff"}}
                type="button" onClick={() => setRank("rank")}>
                Rank wise
              </button> */}
            </div>
          </div>
          {/* Availability */}

          {/* Add Item Button */}
          <button
            className="btn ms-4 d-flex align-items-center"
            style={{ backgroundColor: "#53B7E8", color: "#fff" }}
            onClick={() => navigate("/AddItems", { state: { menuId } })}
          >
            Add Item <span className="fw-bold">&nbsp;+</span>
            {/* <img
              src={"images/plus.svg"}
              alt="Add Icon"
              width={18}
              height={18}
              className="ms-2"
            /> */}
          </button>
        </div>
        <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
          <table className="w-full mt-2 ">
            <thead>
              <tr className="bg-grey font-family font-weight-400 font-size-14  ">
                <th className="p-2 font-weight-400 font-size-14">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="me-2"
                  />
                  Display Name
                </th>
                <th className=" p-2 font-weight-400 font-size-14">Category</th>
                <th className=" p-2 font-weight-400 font-size-14">Code</th>
                <th className=" p-2 font-weight-400 font-size-14">Price</th>
                <th className=" p-2 font-weight-400 font-size-14">
                  Description
                </th>
                <th className=" p-2 font-weight-400 font-size-14">
                  Availability
                </th>
                <th className=" p-2 font-weight-400 font-size-14">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <>
                  <tr>
                    <td colSpan="9" className="text-center">
                      <Loader />
                    </td>
                  </tr>
                </>
              ) : itemList.length > 0 && itemList ? (
                itemList.map((item, index) => (
                  <tr key={item.item_id} className="hover:bg-light border my-2">
                    <td className="p-2 align-middle">
                      <div className="d-flex align-items-center gap-2">
                        {/* {item.is_available == true ? (
                              <div
                                className="bg-success rounded-circle d-inline-block"
                                style={{ width: "10px", height: "10px" }}
                              ></div>
                            ) : (
                              <div
                                className="bg-danger rounded-circle d-inline-block"
                                style={{ width: "10px", height: "10px" }}
                              ></div>
                            )} */}

                        <input
                          type="checkbox"
                          checked={actionsValue?.data?.includes(item.item_id) || false}
                          onChange={() => handleCheckboxChange(item.item_id)}
                        />
                        <div className="border p-2 rounded w-100">
                          {item.item_name}
                        </div>
                      </div>
                    </td>
                    <td className="p-2 align-middle">
                      <div className="border p-2 rounded w-100">
                        {item.category_name}
                      </div>
                    </td>
                    <td className="p-2 align-middle">
                      <div className="border p-2 rounded w-100">
                        {item.short_code}
                      </div>
                    </td>
                    <td className="p-2 align-middle">
                      <div className="ivm-price-wrapper">
                        {item.item_allow_variation == 1 && (
                          <span
                            className="ivm-v-badge"
                            title="View Variations"
                            onClick={() => setVariationModalItem(item)}
                          >
                            V
                          </span>
                        )}
                        {editingPriceId === item.item_id ? (
                          <input
                            type="number"
                            className="border p-1 rounded w-100"
                            value={editingPriceValue}
                            onChange={(e) => setEditingPriceValue(e.target.value)}
                            onBlur={() => handlePriceSave(item.item_id)}
                            onKeyDown={(e) => e.key === "Enter" && handlePriceSave(item.item_id)}
                            autoFocus
                          />
                        ) : (
                          <div className="border p-2 rounded w-100 d-flex align-items-center justify-content-between">
                            <span>{item.item_price}</span>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="p-2 align-middle">
                      <div className="border p-2 rounded w-100">
                        {item.item_description}
                      </div>
                    </td>

                    {/* Toggle for Availability */}
                    <td className="p-2 align-middle">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Form.Check
                          type="switch"
                          id={`switch-${item.item_id}`}
                          checked={switchStates[item.item_id]} // Show toggle ON if is_available is true
                          onChange={() => handleToggle(item.item_id)} // Toggle on click
                        />
                      </div>
                    </td>

                    {/* Actions */}
                    <td className="p-2 align-middle">
                      <div className="d-flex align-items-center gap-2">
                        {!menuId && (
                          <img
                            src="images/ActionEdit.svg"
                            alt="Edit"
                            width={24}
                            height={24}
                            className="cursor-pointer"
                            onClick={() => navigate(`/EditeItem/${item.item_id}`, { state: { menuId } })}
                          />
                        )}
                        {/* Quick Edit Icon */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="#53B7E8"
                          viewBox="0 0 16 16"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleQuickEditOpen(item)}
                          title="Quick Edit"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                          <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="#dc3545"
                          viewBox="0 0 16 16"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDelete(item.item_id)}
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                        </svg>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr className="ErrorDataNotFound">
                    <td colSpan={9}>
                      <NoData />
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <PriceUpdateModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        categoriesData={categoriesData}
        onSave={handleSave}
        getItemList={getItemList}
        menuId={menuId}
      />

      {variationModalItem && (
        <ItemVariationModal
          item={variationModalItem}
          apiConfig={ApiConfig}
          onClose={() => setVariationModalItem(null)}
          onRefresh={getItemList}
          menuId={menuId}
        />
      )}

      {/* Quick Edit Modal */}
      {showQuickEdit && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
        >
          <div className="bg-white rounded-3 p-4" style={{ width: "460px" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">Quick Edit</h6>
              <button className="btn btn-close" onClick={() => setShowQuickEdit(false)} />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Item Name</label>
              <input
                type="text"
                className="form-control"
                value={quickEditData.item_name}
                onChange={(e) => setQuickEditData({ ...quickEditData, item_name: e.target.value })}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Price</label>
              <input
                type="number"
                className="form-control"
                value={quickEditData.item_price}
                onChange={(e) => setQuickEditData({ ...quickEditData, item_price: e.target.value })}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Description</label>
              <textarea
                className="form-control"
                rows={3}
                value={quickEditData.item_description}
                onChange={(e) => setQuickEditData({ ...quickEditData, item_description: e.target.value })}
              />
            </div>

            <div className="mb-4 d-flex align-items-center " style={{gap:'40px'}}>
           
              <label className="form-label fw-semibold mb-0 d-block">Allow Variation</label>
            
              <div className="form-check form-switch ms-2 mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={quickEditData.item_allow_variation === 1}
                  onChange={(e) =>
                    setQuickEditData({ ...quickEditData, item_allow_variation: e.target.checked ? 1 : 0 })
                  }
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary" onClick={() => setShowQuickEdit(false)}>
                Cancel
              </button>
              <button
                className="btn"
                style={{ backgroundColor: "#53B7E8", color: "#fff" }}
                onClick={handleQuickEditSave}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Items;
